import {useParams} from "react-router";
import {css} from "@emotion/react";

import {calculateRemSize as crs, listUnStyled} from "@pg-design/helpers-css-strings";
import {getThemeBreakpoint} from "@pg-design/styles-strings";
import {useUserDevice} from "@pg-mono/user-device";

import {useGetOfferDetailListQuery} from "../../../../offer/api/get_offer_detail_list";
import {useGetRegionDetailListBySlugQuery} from "../../../../region/api/get_region_detail_list_by_slug";
import {rankingBigViewBreakpoint} from "../../../constants/ranking_big_view_breakpoint";
import {offerRedirectTracking} from "../../../tracking/offer_redirect_tracking";
import {IRankingItem} from "../../../types/IRankingItem";
import {IRankingListingViewParams} from "../../../types/IRankingListingViewParams";
import {getRankingItems} from "../../../utils/get_ranking_items";
import {OfferRankingCard} from "./OfferRankingCard";
import {OfferRankingListItem} from "./OfferRankingListItem";

export function OfferRankingList() {
    const userDevice = useUserDevice();
    const {citySlug} = useParams<IRankingListingViewParams>();
    const {data} = useGetRegionDetailListBySlugQuery({slug: citySlug});
    const currentRegion = data?.results[0];
    const rankingItems = currentRegion ? getRankingItems(currentRegion.id) : null;
    const offerIds = rankingItems ? rankingItems.map((item) => item.offerId) : [];
    const {data: rankingOffers} = useGetOfferDetailListQuery({offerIds});

    const podiumItems = rankingItems ? getPodiumItems(rankingItems, Boolean(userDevice.isMobile)) : null;

    const hasAfterPodiumItems = rankingItems ? rankingItems.length > 3 : null;
    const afterPodiumItems = rankingItems ? rankingItems.splice(3, rankingItems.length - 1) : null;

    return (
        <div>
            {currentRegion && rankingOffers && (
                <div css={offerLists}>
                    {podiumItems && (
                        <ul css={podiumList}>
                            {podiumItems.map((item) => {
                                const podiumOffer = rankingOffers.find((offer) => offer.id === item.offerId);

                                if (!podiumOffer) {
                                    return null;
                                }

                                const onOfferTracking = () => {
                                    offerRedirectTracking({
                                        city: currentRegion.name,
                                        position: item.regionOrder,
                                        vendor: podiumOffer.vendor.name,
                                        offerName: podiumOffer.name
                                    });
                                };

                                return (
                                    <OfferRankingCard
                                        key={`rolip_${item.offerId}`}
                                        place={item.regionOrder}
                                        offer={podiumOffer}
                                        onCardClick={onOfferTracking}
                                    />
                                );
                            })}
                        </ul>
                    )}
                    {hasAfterPodiumItems && afterPodiumItems && (
                        <ul css={afterPodiumList}>
                            {afterPodiumItems.map((item) => {
                                const afterPodiumOffer = rankingOffers.find((offer) => offer.id === item.offerId);

                                if (!afterPodiumOffer) {
                                    return null;
                                }
                                const onOfferTracking = () => {
                                    offerRedirectTracking({
                                        city: currentRegion.name,
                                        position: item.regionOrder,
                                        vendor: afterPodiumOffer.vendor.name,
                                        offerName: afterPodiumOffer.name
                                    });
                                };
                                return <OfferRankingListItem key={`roliap_${item.offerId}`} offer={afterPodiumOffer} onItemClick={onOfferTracking} />;
                            })}
                        </ul>
                    )}
                </div>
            )}
        </div>
    );
}

// Utils
function getPodiumItems(sortedItems: IRankingItem[], isMobile: boolean) {
    if (isMobile) {
        return sortedItems.slice(0, 3);
    }

    return [sortedItems[1], sortedItems[0], sortedItems[2]];
}

// Styles
const offerLists = css`
    display: flex;
    flex-direction: column;
    gap: ${crs(3.5)};

    @media (min-width: ${getThemeBreakpoint().md}) {
        gap: ${crs(8.5)};
    }
`;

const podiumList = css`
    ${listUnStyled};
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: ${crs(3)};
    align-items: center;
    justify-content: center;

    @media screen and (min-width: ${rankingBigViewBreakpoint}) {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-template-rows: ${crs(5)} 1fr minmax(${crs(5)}, max-content);
    }
`;

const afterPodiumList = css`
    ${listUnStyled};
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: ${crs(3)};
    align-items: center;
    justify-content: center;
`;
import {useParams} from "react-router";
import {css} from "@emotion/react";

import {calculateRemSize as crs, listUnStyled} from "@pg-design/helpers-css-strings";
import {getThemeBreakpoint} from "@pg-design/styles-strings";
import {useUserDevice} from "@pg-mono/user-device";

import {useGetOfferDetailListQuery} from "../../../../offer/api/get_offer_detail_list";
import {useGetRegionDetailListBySlugQuery} from "../../../../region/api/get_region_detail_list_by_slug";
import {rankingBigViewBreakpoint} from "../../../constants/ranking_big_view_breakpoint";
import {offerRedirectTracking} from "../../../tracking/offer_redirect_tracking";
import {IRankingItem} from "../../../types/IRankingItem";
import {IRankingListingViewParams} from "../../../types/IRankingListingViewParams";
import {getRankingItems} from "../../../utils/get_ranking_items";
import {OfferRankingCard} from "./OfferRankingCard";
import {OfferRankingListItem} from "./OfferRankingListItem";

export function OfferRankingList() {
    const userDevice = useUserDevice();
    const {citySlug} = useParams<IRankingListingViewParams>();
    const {data} = useGetRegionDetailListBySlugQuery({slug: citySlug});
    const currentRegion = data?.results[0];
    const rankingItems = currentRegion ? getRankingItems(currentRegion.id) : null;
    const offerIds = rankingItems ? rankingItems.map((item) => item.offerId) : [];
    const {data: rankingOffers} = useGetOfferDetailListQuery({offerIds});

    const podiumItems = rankingItems ? getPodiumItems(rankingItems, Boolean(userDevice.isMobile)) : null;

    const hasAfterPodiumItems = rankingItems ? rankingItems.length > 3 : null;
    const afterPodiumItems = rankingItems ? rankingItems.splice(3, rankingItems.length - 1) : null;

    return (
        <div>
            {currentRegion && rankingOffers && (
                <div css={offerLists}>
                    {podiumItems && (
                        <ul css={podiumList}>
                            {podiumItems.map((item) => {
                                const podiumOffer = rankingOffers.find((offer) => offer.id === item.offerId);

                                if (!podiumOffer) {
                                    return null;
                                }

                                const onOfferTracking = () => {
                                    offerRedirectTracking({
                                        city: currentRegion.name,
                                        position: item.regionOrder,
                                        vendor: podiumOffer.vendor.name,
                                        offerName: podiumOffer.name
                                    });
                                };

                                return (
                                    <OfferRankingCard
                                        key={`rolip_${item.offerId}`}
                                        place={item.regionOrder}
                                        offer={podiumOffer}
                                        onCardClick={onOfferTracking}
                                    />
                                );
                            })}
                        </ul>
                    )}
                    {hasAfterPodiumItems && afterPodiumItems && (
                        <ul css={afterPodiumList}>
                            {afterPodiumItems.map((item) => {
                                const afterPodiumOffer = rankingOffers.find((offer) => offer.id === item.offerId);

                                if (!afterPodiumOffer) {
                                    return null;
                                }
                                const onOfferTracking = () => {
                                    offerRedirectTracking({
                                        city: currentRegion.name,
                                        position: item.regionOrder,
                                        vendor: afterPodiumOffer.vendor.name,
                                        offerName: afterPodiumOffer.name
                                    });
                                };
                                return <OfferRankingListItem key={`roliap_${item.offerId}`} offer={afterPodiumOffer} onItemClick={onOfferTracking} />;
                            })}
                        </ul>
                    )}
                </div>
            )}
        </div>
    );
}

// Utils
function getPodiumItems(sortedItems: IRankingItem[], isMobile: boolean) {
    if (isMobile) {
        return sortedItems.slice(0, 3);
    }

    return [sortedItems[1], sortedItems[0], sortedItems[2]];
}

// Styles
const offerLists = css`
    display: flex;
    flex-direction: column;
    gap: ${crs(3.5)};

    @media (min-width: ${getThemeBreakpoint().md}) {
        gap: ${crs(8.5)};
    }
`;

const podiumList = css`
    ${listUnStyled};
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: ${crs(3)};
    align-items: center;
    justify-content: center;

    @media screen and (min-width: ${rankingBigViewBreakpoint}) {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-template-rows: ${crs(5)} 1fr minmax(${crs(5)}, max-content);
    }
`;

const afterPodiumList = css`
    ${listUnStyled};
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: ${crs(3)};
    align-items: center;
    justify-content: center;
`;
